import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { MD_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps } from './types';

const TOOLTIP_WIDTH = 220;
const ARROW_POS = -37;

export default createMemoStyles(({ spacing, type, pricingPalette, elevation }: PricingAppTheme) => ({
  Tooltip: {
    position: 'absolute',
    width: TOOLTIP_WIDTH,
    padding: spacing[5],
    backgroundColor: pricingPalette.colors.white,
    borderRadius: 2,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    zIndex: elevation.space,
    '& h5': {
      fontWeight: type.fontWeight.medium,
      marginBottom: spacing[3],
      textTransform: ({ locale }: StyleProps) => (locale === 'en-US' ? 'uppercase' : 'none'),
    },
    '& a': {
      whiteSpace: 'nowrap',
    },
  },
  TooltipArrow: {
    width: 50,
    height: 25,
    position: 'absolute',
    top: '50%',
    overflow: 'hidden',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: 20,
      height: 20,
      background: pricingPalette.colors.white,
      transform: 'translateX(-50%) translateY(-50%) rotate(45deg)',
      top: 0,
      left: '50%',
      boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.2)',
    },
  },
  TooltipLeft: {
    extend: 'Tooltip',
    top: '100%',
    left: 0,
    right: 0,
    width: 'auto',
    '& $TooltipArrow': {
      top: 0,
      right: -3,
      transform: 'translateY(-100%) rotate(180deg)',
    },
    [MD_MEDIA_QUERY]: {
      left: '100%',
      top: '50%',
      width: TOOLTIP_WIDTH,
      transform: 'translate(24px, -50%)',
      '& $TooltipArrow': {
        left: ARROW_POS,
        top: '50%',
        transform: 'translateY(-50%) rotate(90deg)',
      },
    },
  },
  TooltipRight: {
    extend: 'Tooltip',
    right: '100%',
    top: '50%',
    transform: 'translate(-24px, -50%)',
    '& $TooltipArrow': {
      right: ARROW_POS,
      top: '50%',
      transform: 'translateY(-50%) rotate(270deg)',
    },
  },
}));
